import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Responsive from 'react-responsive';
import { styled } from 'styled-components';
import { Sizes } from '../../theme/Media';
import { useTableContext } from './context';
export const Wrapper = styled.p `
  margin: ${({ inline }) => (inline ? '0 10px 0 0' : '0 0 6px')};
  font-size: 12px;
  line-height: 13px;
  color: ${({ theme }) => theme.colors.grey100_1};
  &:not(:first-child) {
    margin-top: 7px;
  }
`;
const MobileLabel = ({ inline, children }) => {
    const { isCollapsedNav } = useTableContext();
    return (_jsx(Responsive, { maxWidth: isCollapsedNav ? Sizes.mdMax : Sizes.lgMax, children: _jsx(Wrapper, { inline: inline, children: children }) }));
};
export default React.memo(MobileLabel);
